import { graphql } from '@/gql';
import type { AbTestCreateInput } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import util from '@/Utils/util';

export const abTestCreate = async (abTestCreate: AbTestCreateInput) => {
  const response = await mutationExecute({
    variables: { abTestCreate },
    mutation: graphql(`
      mutation abTestCreate($abTestCreate: AbTestCreateInput!) {
        abTestCreate(abTestCreate: $abTestCreate) {
          __typename
          id
          name
          type
          description
          status
          startDate
          endDate
          deactivateDate
          createdAt
          updatedAt
          delay
          endAfterNumUsers
          successConditions
          data
          exclusiveKeys
          abTestGroups {
            createdAt
            data
            description
            groupLabel
            groupType
            groupTarget
            associatedObjectType
            associatedObjectId
            winner
            id
            updatedAt
          }
        }
      }
    `),
  });

  if (response.errors?.length) {
    throw new Error(util.getGraphqlError({ graphQLErrors: response.errors }, false), { cause: response });
  }

  if (!response.data?.abTestCreate) {
    throw new Error('Unexpected empty response');
  }

  return response.data.abTestCreate;
};
